export class Accordion {
  constructor(selector) {
    this.elements = $(selector);
  }

  /**
   * Bind accordion click listeners.
   *
   * @return {Accordion}
   */
  setup() {
    this.elements.click(Accordion.slideDown);
    return this;
  }

  /**
   *
   * @param e {MouseEvent|TouchEvent}
   */
  static slideDown(e) {
    e.preventDefault();
    const element = e.target;
    const target = element.dataset.target;

    /**
     *  Add `is-open` class to event.target
     *  might be useful for consumers, i.e to show
     * accordion state indicator.
     */
    element.classList.toggle('is-open');

    /**
     *  Select the next sibling, if no target is provided
     * suitable for most cases.
     */
    if (typeof target === 'undefined') {
      $(element).next().stop().slideToggle();
      return;
    }

    /**
     * Function will reach this line
     * only if data-target is present on event.target.
     */
    $(target).stop().slideToggle();
  }

  /**
   * Remove accordion click listeners.
   *
   * @return {Accordion}
   */
  destroy() {
    this.elements.off('click', Accordion.slideDown);
    return this;
  }
}
